import { toDateTimeStr, toTimestamp } from '../helpers/datetime';
import { universalAtob, universalBtoa } from '../helpers/string';
import { DateTimeStr } from '../types/date';

export interface QuickShare {
  stationId: string;
  from: DateTimeStr | Date;
  to: DateTimeStr | Date;
  title?: string;
}

export function decodeQuickShareHash(hash: string): QuickShare {
  const parsed = universalAtob(hash).split(':');

  const decoded: QuickShare = {
    stationId: parsed[0],
    from: toDateTimeStr(Number(parsed[1])),
    to: toDateTimeStr(Number(parsed[2])),
  };

  if (parsed[3]) {
    decoded.title = parsed[3];
  }

  return decoded;
}

export function encodeQuickShareHash(quick: QuickShare): string {
  return universalBtoa(
    `${quick.stationId}:${toTimestamp(quick.from)}:${toTimestamp(quick.to)}:${quick.title || ''}`,
  );
}

export function getQuickShareUrl(hashOrParameters: string | QuickShare) {
  const hash =
    typeof hashOrParameters === 'string'
      ? hashOrParameters
      : encodeQuickShareHash(hashOrParameters);

  let url;

  switch (import.meta.env.VITE_ENV) {
    case 'prod':
    case 'prod-preview':
      url = 'https://social.mediainbox.io';
      break;
    case 'dev':
    case 'development':
      url = 'https://social-dev.mediainbox.io';
      break;
  }

  return `${url}/quick-share/${hash}`;
}
